import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import desktop from "./images/plp-desktop.jpg";
import xldesktop from "./images/plp-xldesktop.jpg";
import mobile from "./images/plp-mobile.jpg";
import styles from "./styles.module.scss";
import H1Font from "Root/profile/components/common/H1Font";
import LargeFont from "Root/profile/components/common/LargeFont";
import Breadcrumb from "Root/profile/components/BYBFlow/PDP/Breadcrumb";
const PLPBanner = () => {
    return (_jsx(_Fragment, { children: _jsxs("div", { className: styles.banner, children: [_jsx(Breadcrumb, { links: [
                        {
                            title: "Home",
                            href: "/",
                        },
                        {
                            title: "Shop",
                            href: "/shop",
                        },
                    ] }), _jsx("div", { className: styles.wrapper, children: _jsxs("div", { className: styles.text_wrapper, children: [_jsx(H1Font, { fontWeight: 100, children: "Customize Your" }), _jsx("div", { className: styles.systemWrapper, children: _jsx("span", { className: styles.system, children: "System" }) }), _jsxs(LargeFont, { className: styles.text, children: ["Tailor your supplements to your", _jsx(LargeFont, { fontWeight: 400, children: "\u00A0diet, goals, and lifestyle." })] })] }) }), _jsx("div", { className: styles.desktopImage, children: _jsx("img", { src: xldesktop, alt: "gainful assortment of products", height: 500, width: 1440 }) }), _jsx("img", { src: desktop, alt: "gainful assortment of products", className: styles.deskimg }), _jsx("div", { className: styles.mobileImage, children: _jsx("img", { src: mobile, alt: "gainful assortment of products" }) })] }) }));
};
export default PLPBanner;
